import { render, staticRenderFns } from "./UserTab1.vue?vue&type=template&id=b69a7d98&scoped=true"
import script from "./UserTab1.vue?vue&type=script&lang=js"
export * from "./UserTab1.vue?vue&type=script&lang=js"
import style0 from "./UserTab1.vue?vue&type=style&index=0&id=b69a7d98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69a7d98",
  null
  
)

export default component.exports